export const coffeeLength = Object.freeze({"short":1, "medium":2, "long":3})